"use client";
import { useEffect, useState } from "react";

import { useStore, observer } from "../../service/mobx";
import Tabs from "../../component/Tabs";

function Header({ tab }) {
  const [{ tabs, map }, setTabs] = useState({ tabs: [], map: {} });
  const { model } = useStore();

  useEffect(() => {
    const buttons = [
      ["Play", "play"],
      ["API", "api"],
      model.node.closedSource ? undefined : ["Readme", "details"],
      model.related.length ? ["Related", "related"] : undefined
    ].filter(defined => defined);
    const tabs = [];
    const map = {};

    for (const [label, href] of buttons) {
      map[href] = tabs.length.toString();
      tabs.push({ label, href: `/model/${model.node.modelId}/${href}` });
    }

    setTabs({ tabs, map });
  }, [model, model.node.modelId]);

  return tabs.length ? (
    <Tabs
      shallow
      noOutline
      tabs={tabs}
      override={map[tab]}
      initial={map[tab]}
    />
  ) : null;
}

export default observer(Header);
